import {
  Error,
  GetUsers,
  ManageUserClaims,CreateUserDashboard,GetClaims,GetRoles,  DeleteUserdashboard,
  UpdateUserdashboard,
  senEmailtouser,
  getUserAndSubuser,
  getUserSubscriber,
  UpdateUserAndsubdashboard,
  CreatedashNotification,
  getuserNotification,
  notnumber,
  DeleteUsersubscripedashboard
} from "../type";
const initialState = {
  GetRolesAccount: [],
  GetClaimsAccounts: [],
  CreateUserDashboardAccounts: [],
  ManageUserClaimsAccounts: [],
  GetUsersAccounts: [],
  DeleteUserdash: [],
  DeleteUsersubscripedash: [],
  UpdateUserdash: [],
  Email:[],
  UserAndSubuser: [],
  UserSubscriber: [],
  UpdateUserAndsubuserdash:[],
  CreateNotification:[],
  getNotification:[],
  getNotnumber:[],
  loading: false,
};
const ManageAdminR = (state = initialState, action) => {
  switch (action.type) {
    case GetUsers:
      return {
        ...state,
        GetUsersAccounts: action.payload,
        loading: false,
      };
      case notnumber:
        return {
          ...state,
          getNotnumber: action.payload,
          loading: false,
        };
      case getUserAndSubuser:
        return {
          ...state,
          UserAndSubuser: action.payload,
          loading: false,
        };
        case getUserSubscriber:
          return {
            ...state,
            UserSubscriber: action.payload,
            loading: false,
          };
          case getuserNotification:
            return {
              ...state,
              getNotification: action.payload,
              loading: false,
            };
            case CreatedashNotification:
              return {
                ...state,
                CreateNotification: action.payload,
                loading: false,
              };
    case ManageUserClaims:
      return {
        ManageUserClaimsAccounts: action.payload,
        loading: false,
      };
    case CreateUserDashboard:
      return {
        GetUsersAccounts:state.GetUsersAccounts,
        CreateUserDashboardAccounts: action.payload,
        loading: false,
      };
      case senEmailtouser:
        return {
          Email: action.payload,
          loading: false,
        };
    case GetClaims:
      return {
        ...state,
        GetClaimsAccounts: action.payload,
        loading: false,
      };
    case GetRoles:
      return {
        ...state,   
        GetRolesAccount: action.payload,
        loading: false,
      };
      case UpdateUserdashboard:
        return {
          GetUsersAccounts:state.GetUsersAccounts,
          UpdateUserdash: action.payload,
          loading: false,
        };
        case UpdateUserAndsubdashboard:
          return {
            UpdateUserAndsubuserdash: action.payload,
            loading: false,
          };
        case DeleteUserdashboard:
          return {
            
            DeleteUserdash: action.payload,
            loading: false,
          };
          case DeleteUsersubscripedashboard:
            return {
              DeleteUsersubscripedash: action.payload,
              loading: false,
            };
    case Error:
      return {
        loading: false,
        GetUsersAccounts: action.payload,
      };
    default:
      return state;
  }
};
export default ManageAdminR;
